import { useSoyuzData } from '@spotahome/soyuz/client';
import { ThemeProvider, UserInfoProvider } from '@spotahome/ui-library';

import RefereeContainer from './RefereeContainer';
import RefereeContainerRevamp from './RefereeContainerRevamp';

const RefereePage = () => {
  const { [RefereePage.NAME]: requestedData } = useSoyuzData();
  const { loggedIn, deviceType } = requestedData;

  const isRedesign = deviceType === 'desktop';

  return (
    <ThemeProvider flags={{ newButtons: true }}>
      <UserInfoProvider>
        {isRedesign ? (
          <RefereeContainerRevamp loggedIn={loggedIn} />
        ) : (
          <RefereeContainer loggedIn={loggedIn} />
        )}
        ;
      </UserInfoProvider>
    </ThemeProvider>
  );
};

RefereePage.NAME = 'RefereePageName';

RefereePage.requestData = req => ({
  data: {
    loggedIn: !!req.getAccessToken(),
    deviceType: req.device.type
  }
});

export default RefereePage;
